import React from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap CSS is imported
import { Link, useNavigate } from "react-router-dom";
import { Button } from 'reactstrap'; // Import Button from reactstrap
import { FiLogOut } from "react-icons/fi"; // Importing a logout icon from react-icons/fi

const widgetData = [
  {
    img: require("./../assets/widgets/hire.png"),
    alt: "Hire Module",
    label: "Hire Module",
    link : "/profile"
  },
  {
    img: require("./../assets/widgets/Employee.png"),
    alt: "Employee Management",
    label: "Employee Management",
    link : "/members"

  },
  {
    img: require("./../assets/widgets/attendence.png"),
    alt: "Attendance",
    label: "Attendance",
    link : "/profile"

  },
  {
    img: require("./../assets/widgets/finance.png"),
    alt: "Finance",
    label: "Finance",
    link : "/profile"

  },
  {
    img: require("./../assets/widgets/homecare.png"),
    alt: "Home Care",
    label: "Home Care",
    link : "/profile"

  },
  {
    img: require("./../assets/widgets/restaurent.png"),
    alt: "Restaurant",
    label: "Restaurant",
    link : "/profile"

  },
  {
    img: require("./../assets/widgets/settings.png"),
    alt: "Settings",
    label: "Settings",
    link : "/product?category=employee_management&subCategory=employees"

  },
];



const ProductWidget = () => {
      const navigate = useNavigate();
   const handleLogout = () => {
        localStorage.removeItem('admin-auth-token');
        navigate('/login');
    };
  return (
    <div className="product-widget-outer" style={{ position: 'relative' }}>
        <Button
          color="danger" // Bootstrap color classes
          outline // Equivalent to CoreUI's variant="outline"
          className="position-absolute top-0 end-0 m-3 d-flex align-items-center"
          onClick={handleLogout}
          style={{ zIndex: 10 }}
        >
          <FiLogOut className="me-2" style={{ fontSize: '1.25rem' }} /> {/* Using react-icons component */}
          Logout
        </Button>
      

      <div className="container">
        <div className="product-widget mx-auto">
          <ul className="list-unstyled text-center">
            {widgetData.map((item, index) => (
              <li key={index}>
                <Link to={item.link}>
                  <span className="wgt-icon">
                    <img src={item.img} alt={item.alt} />
                  </span>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProductWidget;